import React from "react";
import { Row, Col } from 'reactstrap';
import ErrorBoundary from "../../Components/Common/ErrorBoundary";
import { formatdate_DMY } from "../../utils/formatdate_DMY.js"
const PreviousTickets = ({ previousticketsdata }) => {
    return (
        <div>
            <ErrorBoundary fallback={<div>Oops! Something went wrong </div>}>
                <Row>
                    <Col lg={12}>
                        {
                            previousticketsdata?.ticket_comments?.map(ele => {

                                return (



                                    <table className='table table-hover'>
                                        <thead>
                                        </thead>
                                        <tbody>    <tr >
                                            <td style={{ width: '30%' }}>
                                                <div>
                                                    <span>{ele.title}</span><br />
                                                    <span>{formatdate_DMY(ele?.comment_date, "DD-MM-YYYY HH:mm")}</span>
                                                </div>
                                            </td>
                                            <td style={{ width: '70%' }}>
                                                <span>{ele.comment}</span>
                                            </td>
                                        </tr></tbody>
                                    </table>



                                )
                            })
                        }
                    </Col>

                </Row>
            </ErrorBoundary>
        </div>
    )
}
export default React.memo(PreviousTickets);